module.exports = __webpack_public_path__ + "files/ea284cc760cad1896d4c917f1e546210.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-300.woff2
// module id = 705
// module chunks = 60